import React from 'react';
import * as comparators from 'modules/queryBuilder/legacyQueryBuilder/utils/comparators';
import { isDefined } from 'utils/tsHelpers';
import { getComparatorValue } from './utils/getComparatorValue';
import { Label, StyledCoreDropdown } from './ComparatorDropdown.styled';
import { getOptionsForType } from './ComparatorDropdown.utils';

// type Props = {
//   /** List of comparators for boolean type. */
//   booleanTypeComparators: [],
//   /** List of comparators for campaign label type. */
//   campaignLabelsComparators: [],
//   /** List of comparators for date type. */
//   dateTypeComparators: [],
//   /** List of default comparators. */
//   defaultComparators: [],
//   /** If dropdown is disabled. */
//   disabled: boolean,
//   /** If the dropdown has an error. */
//   error: boolean,
//   /** esIndex */
//   esIndex: QueryBuilderIndex
//   /** The currently selected field. */
//   field: string,
//   /** List of comparators for geo type. */
//   geoLocationTypeComparators: [],
//   /** If isMultiSelectInputAllowed */
//   isMultiSelectInputAllowed: boolean
//   /** List of comparators for list type. */
//   listTypeComparators: [],
//   /** List of comparators for numberic types. */
//   numericTypeComparators: [],
//   /** List of comparators for object type. */
//   objectTypeComparators: [],
//   /** Callback function when value changes. */
//   onChange: (e: {}, data: { value: string }) => void,
//   /** Placeholder text of the dropdown. */
//   placeholder: string,
//   /** List of comparators for string type. */
//   stringTypeComparators: [],
//   /** List of symbols that are not shown in view mode. */
//   symbolsNotShownOnView: [],
//   /** The currently selected field type. */
//   type: string,
//   /** The currently selected value. */
//   value: string,
// };

export default class ComparatorDropdown extends React.Component {
  static defaultProps = {
    booleanTypeComparators: comparators.booleanTypeComparators,
    brandAffinityComparators: comparators.brandAffinityComparators,
    campaignLabelsComparators: comparators.campaignLabelsComparators,
    dateTypeComparators: comparators.dateTypeComparators,
    defaultComparators: comparators.defaultComparators,
    geoLocationTypeComparators: comparators.geoLocationTypeComparators,
    listTypeComparators: comparators.listTypeComparators,
    numericTypeComparators: comparators.numericTypeComparators,
    multiSelectInputComparators: comparators.multiSelectInputComparators,
    objectTypeComparators: comparators.objectTypeComparators,
    stringTypeComparators: comparators.stringTypeComparators,
    regexTypeComparators: comparators.regexTypeComparators,
    symbolsNotShownOnView: comparators.symbolsNotShownOnView,
    placeholder: 'Comparator...',
    disabled: false,
    isMultiSelectInputAllowed: false,
    isMultiSelectWithListMembershipAllowed: false,
  };

  /**
   * getOptions
   * Gets the list of comparators for the dropdown.
   * @returns { Array } List of comparators.
   */
  getOptions = () => {
    const { type, field, symbolsNotShownOnView } = this.props;
    const options = getOptionsForType(type, field, this.props);
    const comparator = getComparatorValue(this.props);

    const dropdownOptions = options.map((option) => {
      const { multiText, description, value: optionValue, id, ...otherOptions } = option;
      const updatedValue = id ?? optionValue;
      return {
        ...otherOptions,
        description,
        value: updatedValue,
        icon: description ? <span>{description}</span> : <span />,
      };
    });
    const selectedOption = dropdownOptions.filter((option) => option.value === comparator)[0] || {};

    const { description, text } = selectedOption;
    const symbolShown = !symbolsNotShownOnView.includes(description) && isDefined(description);

    return {
      label: symbolShown ? description : text,
      options: dropdownOptions,
      symbolShown,
      comparator,
    };
  };

  render() {
    const { disabled, error, onChange, placeholder } = this.props;
    const { label, options, symbolShown, comparator } = this.getOptions();

    return (
      <>
        <Label symbolShown={symbolShown}>{label}</Label>
        <StyledCoreDropdown
          searchInput={{ autoComplete: 'chrome-off' }}
          data-test="collections-comparator-dropdown"
          disabled={disabled}
          isError={error}
          search
          onChange={onChange}
          options={options}
          placeholder={placeholder}
          value={comparator}
        />
      </>
    );
  }
}
